import { ACCESS_TOKEN_KEY, ACCESS_USERID_KEY } from '@/constant/config';
import { request } from '@/utils/request';
import Storage from '@/utils/Storage';
import { getDevice } from '@/utils/utils';

export const getVerifyCode = (params: API.GetVerifyCode) => {
  return request({
    url: '/login/bl_get_verify_code',
    params
  });
};

export const login = (data: API.LoginRequest | API.TouristsLoginRequest) => {
  return request({
    url: '/login/bl_login',
    method: 'post',
    data
  });
};

export const logout = () => {
  return request({
    url: '/gamer/logout',
    method: 'post'
  });
};

/**
 * 检查手机号
 */
export const checkMobile = (data: API.BindMobileRequest) => {
  return request({
    url: '/yfapi/QPGameUserDB.gsp_gr_mobilecheck',
    method: 'post',
    data
  });
};

export const touristsLogin = () => {
  return request({
    url: '/login/tourists_login',
    method: 'post'
  });
};

/**
 * 绑定手机号
 */
export const bindMobile = (data: API.BindMobileRequest) => {
  return request({
    url: '/yfapi/QPGameUserDB.GSP_GP_ManageMobile',
    method: 'post',
    data
  });
};

export const getDesktopReward = () => {
  const device = getDevice();
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  const token = Storage.getAccess(ACCESS_TOKEN_KEY);
  if (device === 'ios') {
    return request(
      {
        url: '/api/login/get_ios_collect_reward',
        method: 'post',
        data: {
          userid,
          token,
          p_userid: userid,
          ios_collect: 1
        }
      },
      {
        skipErrorHandle: true
      }
    );
  }
  return request(
    {
      url: '/login/bl_get_desktop_reward',
      method: 'post',
      data: {
        userid,
        token,
        p_userid: userid,
        open_from: 1
      }
    },
    {
      skipErrorHandle: true
    }
  );
};

export const whatsappShareBind = (data: Record<string, any>) => {
  return request(
    {
      url: '/gamesvr/sharebind',
      method: 'post',
      data
    },
    {
      skipErrorHandle: true
    }
  );
};
